import { createFileRoute } from '@tanstack/react-router';
import { Field } from '@osd/ui/field';
import { Input } from '@osd/ui/input';
import { Stack } from '@osd/ui/stack';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/input — live docs for the `Input` primitive.
 */
export const Route = createFileRoute('/ui/_layout/input')({
  component: InputPage,
});

function InputPage() {
  return (
    <Stack gap={6}>
      <Section
        title="Input"
        hint="text input — uncontrolled (name) or controlled (value + onChange)"
      >
        <Stack gap={3}>
          <Field label="Email" hint="We never share your email.">
            <Input name="email" type="email" placeholder="you@example.com" />
          </Field>
          <Field label="Password">
            <Input name="password" type="password" />
          </Field>
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            title="Basic — uncontrolled"
            language="tsx"
            code={`<Field label="Email">
  <Input name="email" type="email" />
</Field>`}
          />

          <CodeBlock
            title="Controlled — with useForm"
            language="tsx"
            code={`<Field
  label="Email"
  error={form.touched.email ? form.errors.email : null}
>
  <Input
    name="email"
    type="email"
    value={form.values.email}
    onChange={form.handleChange}
    onBlur={form.handleBlur}
  />
</Field>`}
          />

          <CodeBlock
            title="With hint"
            language="tsx"
            code={`<Field
  label="Username"
  hint="3–20 characters, letters and numbers only"
>
  <Input name="username" />
</Field>`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
